export { default as DocumentPageEditor } from "./DocumentPageEditor.vue";
export { default as EditMenuContainer } from "./EditMenuContainer.vue";
export { default as DocumentEditModeIndicator } from "./DocumentEditModeIndicator.vue";
export { default as DocumentAttributesEditor } from "./DocumentAttributesEditor.vue";
export { default as DocumentEditorMenu } from "./DocumentEditorMenu.vue";
export * from "./IToolTabDefinition";
export { default as ToolContainer } from "./ToolContainer.vue";
export { default as FormatMenu } from "./FormatMenu.vue";
export { default as ReferenceFileMenu } from "./ReferenceFileMenu.vue";
export { default as PageNavigator } from "./PageNavigator.vue";
export { default as EmbeddedEditMenuContainer } from "./EmbeddedEditMenuContainer.vue";
export { default as DocumentExternalMenu } from "./DocumentExternalMenu.vue";
export * from "./IDocumentEditMenuConfiguration";
